import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PropTypes from "prop-types";
import React from "react";

const Sortable = ({ id, path, children }) => {
  const { attributes, listeners, setNodeRef, transform } = useSortable({
    id,
    data: { path },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "100%",
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children &&
        React.cloneElement(children, {
          dndProperties: { ...listeners, ...attributes },
        })}
    </div>
  );
};

Sortable.propTypes = {
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Sortable;
